/* =====================================================================
 * Filmposter-Editor (PROJ-34) - Streaming-Look, Lovestory/Besties
 * ABGELEITET vom Magazin-Editor (PROJ-33): identische Foto-Maschinerie
 * (Upload/Crop/Filter/Quality/Default), eigenes Serien-Chrome.
 * =====================================================================
 * Vollflaechiges Kundenfoto + Magazin-Chrome. Kopiervorlagen:
 * - Chrome/Tabs/Produkt-Tab/Cart-Add: kalender-poster.js (JG-Schema)
 * - Foto-Upload (S3 presigned) + Crop-Modal (Cropper.js): letter-poster.js
 *
 * PRINT-MATCH: Die Live-Vorschau spiegelt renderFilmposter() aus
 * citymap-server/blanket_frontend/print-mode.js 1:1 (mpText-Positionen,
 * cqw-Groessen, Barcode, Scrim). Aendert sich der Server, hier mitziehen.
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.FP_BACKEND_API_URL || 'https://tiles.distantlines.de';
  var MAX_FILE_SIZE_MB = 20;
  var CROPPER_CSS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.css';
  var CROPPER_JS_URL = 'https://cdn.jsdelivr.net/npm/cropperjs@1.6.2/dist/cropper.min.js';

  /* ---- Geteilte Layout-Konstanten (MUESSEN dem Server entsprechen) ---- */
  var SANS = "'Outfit', system-ui, sans-serif";
  var SERIF = "'Playfair Display', Georgia, serif";
  var MP_BARCODE = [3,1,1,2,2,1,3,1,1,1,2,3,1,2,1,1,3,1,2,1,1,2,3,1];
  /* 1:1 Fotoposter (photo.js/photo.css): Filter-Defs + Quality-Schwellen */
  var MP_FILTERS = {
    none: 'none',
    cool: 'saturate(0.85) hue-rotate(-10deg) brightness(1.05)',
    bw: 'grayscale(1) contrast(1.05)',
    soft: 'saturate(0.6) brightness(1.05) contrast(0.95)',
    sepia: 'sepia(0.85) saturate(1.1) brightness(0.95)',
    sommer: 'saturate(1.25) brightness(1.08) hue-rotate(-5deg)',
    vintage: 'sepia(0.4) saturate(1.4) hue-rotate(-15deg) brightness(0.92)'
  };
  var QUALITY_THRESHOLDS = { green: 100, orange: 75 };

  /* ---- Modul-State ---- */
  var root, stage, sectionId;
  var state = {
    titel: 'LOVESTORY', staffel_zeile: '', cast_zeile: '',
    text_color: 'light',      // 'light' | 'dark'
    scrim: true,
    filter: 'none',
    natural_width: null, natural_height: null,
    serie_zeile: '', tagline: '',  // fest (Section-Settings, nicht kundeneditierbar)
    user_image_url: '',       // S3-URL (Payload)
    crop: null,               // {x,y,w,h} 0..1
    paper_size: '30x40', variant_id: '', product_type: '', frame_color: 'brown'
  };
  var photoPreviewUrl = '';   // objectURL fuer die Vorschau
  var cropSourceUrl = '';     // dataURL fuers Crop-Modal
  var isDefaultPhoto = false; // Default-Mockup aktiv (Fotoposter-Muster: Filter
                              // sofort erlebbar; wird NIE gedruckt/hochgeladen)

  /* ===================================================================
   * Render - 1:1-Spiegel von renderFilmposter() (Server print-mode.js)
   * =================================================================== */
  function mpText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var align = o.align || 'center';
    var css = 'position:absolute;z-index:6;display:block;top:' + o.y + '%;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + o.color + ';line-height:' + (o.lh || 1.2) + ';';
    if (align === 'left') { css += 'left:' + o.x + '%;transform:translate(0,-50%);text-align:left;'; }
    else if (align === 'right') { css += 'right:' + (100 - o.x) + '%;transform:translate(0,-50%);text-align:right;'; }
    else { css += 'left:' + o.x + '%;transform:translate(-50%,-50%);text-align:center;'; }
    if (o.wrap) { css += 'width:' + o.wrap + '%;white-space:normal;'; }
    else { css += 'white-space:nowrap;'; }
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    if (o.italic) css += 'font-style:italic;';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }

  function mpFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  function applyCropStyles(img, crop) {
    if (!crop) {
      img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;';
      return;
    }
    img.style.cssText = '';
    img.style.inset = 'auto';
    img.style.position = 'absolute';
    img.style.left = (-(crop.x / crop.w) * 100) + '%';
    img.style.top = (-(crop.y / crop.h) * 100) + '%';
    img.style.width = (100 / crop.w) + '%';
    img.style.height = (100 / crop.h) + '%';
    img.style.maxWidth = 'none';
    img.style.objectFit = 'cover';
  }

  function render() {
    if (!stage) return;
    var tc = state.text_color === 'dark' ? '#1d1d1d' : '#ffffff';

    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.backgroundColor = '#e9e9e9';
    grid.style.borderRadius = '0';

    // ---- Foto vollflaechig ----
    var photoWrap = document.createElement('div');
    photoWrap.style.cssText = 'position:absolute;inset:0;overflow:hidden;z-index:1;';
    if (photoPreviewUrl) {
      var img = document.createElement('img');
      img.alt = '';
      img.src = photoPreviewUrl;
      applyCropStyles(img, state.crop);
      var mpf = MP_FILTERS[state.filter] || 'none';
      if (mpf !== 'none') img.style.filter = mpf;
      photoWrap.appendChild(img);
    }
    grid.appendChild(photoWrap);

    // ---- Scrim: IMMER an, adaptiv an die Textfarbe (1:1 Server, Dominik 2026-07-08) ----
    var scrim = document.createElement('div');
    var scrimDark = state.text_color === 'dark';
    scrim.style.cssText = 'position:absolute;inset:0;z-index:2;pointer-events:none;background:linear-gradient(180deg,' +
      (scrimDark ? 'rgba(255,255,255,0.30)' : 'rgba(0,0,0,0.32)') + ' 0%,rgba(0,0,0,0) 22%,rgba(0,0,0,0) 42%,' +
      (scrimDark ? 'rgba(255,255,255,0.62)' : 'rgba(0,0,0,0.68)') + ' 100%);';
    grid.appendChild(scrim);

    // ---- Serien-Chrome (identische Werte wie renderFilmposter im Server!) ----
    mpText(grid, { content: state.serie_zeile || 'Eine Original Serie', x: 50, y: 7.5, font: SANS, weight: 600, size: 1.8, color: tc, upper: true, spacing: '0.5em' });
    var elTitel = mpText(grid, { content: state.titel || 'LOVESTORY', x: 50, y: 66, font: SANS, weight: 700, size: 9.5, color: tc, upper: true, spacing: '0.10em', lh: 1 });
    mpText(grid, { content: state.staffel_zeile, x: 50, y: 73, font: SANS, weight: 500, size: 2.1, color: tc, upper: true, spacing: '0.28em' });
    var elCast = mpText(grid, { content: state.cast_zeile, x: 50, y: 78, font: SERIF, weight: 600, size: 2.8, color: tc, upper: true, spacing: '0.06em' });
    mpText(grid, { content: state.tagline, x: 50, y: 83.5, font: SERIF, weight: 500, size: 1.8, color: tc, italic: true, spacing: '0.03em', wrap: 70, lh: 1.4 });

    var bar = document.createElement('div');
    bar.style.cssText = 'position:absolute;left:8%;right:8%;bottom:7%;z-index:6;';
    bar.innerHTML =
      '<svg viewBox="0 0 100 4" preserveAspectRatio="none" style="display:block;width:100%;height:0.9cqw;">' +
        '<rect x="0" y="1.5" width="100" height="1" fill="' + tc + '" opacity="0.35"/>' +
        '<rect x="0" y="1.5" width="35" height="1" fill="' + tc + '"/>' +
        '<circle cx="35" cy="2" r="1.8" fill="' + tc + '"/>' +
      '</svg>';
    grid.appendChild(bar);
    mpText(grid, { content: '1:07', x: 8, y: 95, align: 'left', font: SANS, weight: 500, size: 1.4, color: tc, spacing: '0.08em' });
    mpText(grid, { content: '1:43', x: 92, y: 95, align: 'right', font: SANS, weight: 500, size: 1.4, color: tc, spacing: '0.08em' });

    // ---- Editor-only: Foto-CTA nur wenn GAR kein Bild (Default zaehlt als Bild) ----
    if (!photoPreviewUrl) {
      var cta = document.createElement('div');
      cta.className = 'fp-photo-cta';
      cta.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg><span>Foto hochladen</span>';
      cta.addEventListener('click', pickPhoto);
      grid.appendChild(cta);
    }

    stage.innerHTML = '';
    stage.appendChild(grid);

    var fitReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    fitReady.then(function () {
      mpFit(elTitel, 88);
      mpFit(elCast, 84);
    });
  }

  /* ===================================================================
   * Foto: Upload (S3 presigned, letter-poster-Muster) + Crop-Modal
   * =================================================================== */
  function pickPhoto() {
    var fileInput = document.getElementById('fp-file-input');
    if (fileInput) fileInput.click();
  }

  function handleFile(file) {
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert('Das Foto ist groesser als ' + MAX_FILE_SIZE_MB + ' MB - bitte ein kleineres waehlen.');
      return;
    }
    var reader = new FileReader();
    reader.onload = function () {
      cropSourceUrl = String(reader.result);
      photoPreviewUrl = cropSourceUrl;
      isDefaultPhoto = false;
      state.crop = null;
      var probe = new Image();
      probe.onload = function () {
        state.natural_width = probe.naturalWidth;
        state.natural_height = probe.naturalHeight;
        updatePhotoUiState();
      };
      probe.src = cropSourceUrl;
      render();
      updatePhotoUiState();
      openCropModal();
    };
    reader.readAsDataURL(file);

    // Upload parallel (Payload braucht die S3-URL)
    uploadToS3(file).then(function (publicUrl) {
      state.user_image_url = publicUrl;
    }).catch(function (err) {
      console.error('[film-poster] S3 upload failed', err);
      state.user_image_url = '';
    });
  }

  async function uploadToS3(file) {
    // 1:1 letter-poster.js: presigned POST mit FormData-Fields (KEIN PUT -
    // der scheitert am Objectstorage-CORS-Preflight)
    var presignedResp = await fetch(BACKEND_API_URL + '/api/v1/upload/presigned-url/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file.name || 'film-photo.jpg', content_type: file.type || 'image/jpeg' })
    });
    if (!presignedResp.ok) throw new Error('Presigned URL failed: HTTP ' + presignedResp.status);
    var presigned = await presignedResp.json();
    var uploadUrl = presigned.uploadUrl || presigned.upload_url;
    var publicUrl = presigned.publicUrl || presigned.public_url;
    var fields = presigned.fields || {};
    if (!uploadUrl || !publicUrl) throw new Error('Invalid presigned response');
    var formData = new FormData();
    Object.keys(fields).forEach(function (k) { formData.append(k, fields[k]); });
    formData.append('file', file);
    var uploadResp = await fetch(uploadUrl, { method: 'POST', body: formData });
    if (!uploadResp.ok && uploadResp.status !== 204) throw new Error('S3 upload failed: HTTP ' + uploadResp.status);
    return publicUrl;
  }

  /* ---- Crop-Modal (Cropper.js on-demand, Kissen/Letterposter-Muster) ---- */
  var _cropper = null, _cropBackdrop = null, _cropInitialRatio = null;
  function ensureCropper() {
    return new Promise(function (resolve, reject) {
      if (window.Cropper) { resolve(); return; }
      if (!document.querySelector('link[data-cropper]')) {
        var lk = document.createElement('link');
        lk.rel = 'stylesheet'; lk.href = CROPPER_CSS_URL; lk.setAttribute('data-cropper', '1');
        document.head.appendChild(lk);
      }
      var sc = document.createElement('script');
      sc.src = CROPPER_JS_URL;
      sc.onload = function () { resolve(); };
      sc.onerror = function () { reject(new Error('Cropper konnte nicht geladen werden')); };
      document.head.appendChild(sc);
    });
  }
  function buildCropBackdrop() {
    var bd = document.createElement('div');
    bd.className = 'collage-cropper-modal-backdrop';
    bd.innerHTML =
      '<div class="collage-cropper-modal">' +
        '<div class="collage-cropper-modal-header"><h3>Foto zuschneiden</h3></div>' +
        '<div class="collage-cropper-wrapper"><img alt=""></div>' +
        '<p class="collage-cropper-help">Verschiebe den Rahmen oder zoome, bis dein Motiv sitzt - der Ausschnitt fuellt das ganze Cover.</p>' +
        '<div class="collage-cropper-zoom-bar">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-out" aria-label="Verkleinern">&minus;</button>' +
          '<input type="range" class="collage-zoom-slider" min="100" max="200" value="100" aria-label="Zoom">' +
          '<button type="button" class="collage-zoom-btn collage-zoom-in" aria-label="Vergrößern">+</button>' +
        '</div>' +
        '<div class="collage-cropper-modal-footer">' +
          '<button type="button" class="collage-crop-cancel">Abbrechen</button>' +
          '<button type="button" class="primary collage-crop-apply">Zuschneiden &amp; übernehmen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(bd);
    bd.addEventListener('click', function (e) { if (e.target === bd) closeCropModal(); });
    bd.querySelector('.collage-crop-cancel').addEventListener('click', closeCropModal);
    bd.querySelector('.collage-crop-apply').addEventListener('click', applyCropFromModal);
    var zs = bd.querySelector('.collage-zoom-slider');
    if (zs) zs.addEventListener('input', function () {
      if (!_cropper || !_cropInitialRatio) return;
      _cropper.zoomTo(_cropInitialRatio * (parseInt(this.value, 10) / 100));
    });
    bd.querySelector('.collage-zoom-in').addEventListener('click', function () { if (_cropper) _cropper.zoom(0.1); });
    bd.querySelector('.collage-zoom-out').addEventListener('click', function () { if (_cropper) _cropper.zoom(-0.1); });
    return bd;
  }
  function posterAspect() {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(state.paper_size || '');
    var w = m ? parseInt(m[1], 10) : 30, h = m ? parseInt(m[2], 10) : 40;
    var shortE = Math.min(w, h), longE = Math.max(w, h);
    return shortE / longE;   // Cover ist immer Hochformat
  }
  function openCropModal() {
    if (!cropSourceUrl) { pickPhoto(); return; }
    ensureCropper().then(function () {
      if (!_cropBackdrop) _cropBackdrop = buildCropBackdrop();
      _cropBackdrop.classList.add('visible');
      document.body.style.overflow = 'hidden';
      initCropperImage();
    }).catch(function (e) { console.error(e); alert('Crop-Editor konnte nicht geladen werden.'); });
  }
  function initCropperImage() {
    var img = _cropBackdrop.querySelector('.collage-cropper-wrapper img');
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    var _built = false;
    img.onload = function () {
      if (_built) return; _built = true;
      requestAnimationFrame(function () {
        _cropper = new Cropper(img, {
          aspectRatio: posterAspect(),
          viewMode: 1, autoCropArea: 1,
          movable: true, zoomable: true, rotatable: false, scalable: false,
          cropBoxResizable: true, responsive: false, background: false, modal: true,
          dragMode: 'none', toggleDragModeOnDblclick: false, // kein Neu-Aufziehen ausserhalb der Box (Clarity 10.08.)
          minCropBoxWidth: 60, minCropBoxHeight: 60,
          wheelZoomRatio: 0.08,
          ready: function () {
            var cd = _cropper.getCanvasData();
            _cropInitialRatio = cd.naturalWidth ? (cd.width / cd.naturalWidth) : null;
            var zs = _cropBackdrop && _cropBackdrop.querySelector('.collage-zoom-slider');
            if (zs) zs.value = 100;
            if (state.crop) {
              var d = _cropper.getImageData();
              _cropper.setData({ x: state.crop.x * d.naturalWidth, y: state.crop.y * d.naturalHeight, width: state.crop.w * d.naturalWidth, height: state.crop.h * d.naturalHeight });
            }
          }
        });
      });
    };
    img.src = cropSourceUrl;
    if (img.complete && img.naturalWidth) img.onload();
  }
  function applyCropFromModal() {
    if (!_cropper) { closeCropModal(); return; }
    var data = _cropper.getData();
    var id = _cropper.getImageData();
    var NW = id.naturalWidth || 1, NH = id.naturalHeight || 1;
    state.crop = {
      x: Math.max(0, Math.min(1, data.x / NW)),
      y: Math.max(0, Math.min(1, data.y / NH)),
      w: Math.max(0.01, Math.min(1, data.width / NW)),
      h: Math.max(0.01, Math.min(1, data.height / NH))
    };
    closeCropModal();
    render();
    updatePhotoUiState();
  }
  function closeCropModal() {
    if (_cropper) { _cropper.destroy(); _cropper = null; }
    if (_cropBackdrop) _cropBackdrop.classList.remove('visible');
    document.body.style.overflow = '';
  }

  /* ===================================================================
   * Foto-UI-Zustaende + Qualitaetsanzeige + Filter (1:1 Fotoposter-Muster)
   * =================================================================== */
  function updatePhotoUiState() {
    var hasCustomerPhoto = !!photoPreviewUrl && !isDefaultPhoto;
    var changeRow = document.getElementById('fp-change-row');
    if (changeRow) changeRow.classList.toggle('visible', hasCustomerPhoto);
    var uploadBtn = document.getElementById('fp-upload-zone');
    if (uploadBtn) uploadBtn.style.display = hasCustomerPhoto ? 'none' : '';
    var hint = root.querySelector('.photo-upload-hint');
    if (hint) hint.style.display = hasCustomerPhoto ? 'none' : '';
    // Filter immer zeigen, sobald IRGENDEIN Bild da ist (auch das Default -
    // Fotoposter-Muster: Kunde kann sofort durchzappen)
    var stageHint = document.getElementById('fp-stage-hint-' + sectionId);
    if (stageHint) stageHint.style.display = isDefaultPhoto ? '' : 'none';
    var picker = document.getElementById('fp-filter-picker');
    if (picker) {
      picker.style.display = photoPreviewUrl ? '' : 'none';
      if (photoPreviewUrl) picker.querySelectorAll('.filter-thumb-img').forEach(function (im) {
        if (im.src !== photoPreviewUrl) im.src = photoPreviewUrl;
      });
    }
    updateQualityIndicator();
  }

  function computeQualityForPaperSize(paperWidthCm, paperHeightCm) {
    if (!state.natural_width || !state.natural_height) return null;
    var cropW = (state.crop && state.crop.w) || 1;
    var cropH = (state.crop && state.crop.h) || 1;
    var dpiW = (state.natural_width * cropW) / (paperWidthCm / 2.54);
    var dpiH = (state.natural_height * cropH) / (paperHeightCm / 2.54);
    var dpi = Math.min(dpiW, dpiH);
    var level = dpi >= QUALITY_THRESHOLDS.green ? 'green' : (dpi >= QUALITY_THRESHOLDS.orange ? 'orange' : 'red');
    return { level: level, dpi: Math.round(dpi) };
  }

  function updateQualityIndicator() {
    var btn = document.getElementById('fp-quality-btn');
    if (!btn) return;
    if (!state.natural_width || !photoPreviewUrl || isDefaultPhoto) { btn.style.display = 'none'; return; }
    var dim = parsePosterDim(state.paper_size);
    var shortE = Math.min(dim.w, dim.h), longE = Math.max(dim.w, dim.h);
    var result = computeQualityForPaperSize(shortE, longE);
    if (!result) { btn.style.display = 'none'; return; }
    btn.style.display = 'flex';
    btn.setAttribute('data-level', result.level);
    var statusEl = btn.querySelector('.quality-status');
    var labels = { green: 'Ausgezeichnet', orange: 'Akzeptabel', red: 'Niedrig' };
    if (statusEl) statusEl.textContent = labels[result.level] || '';
    var iconEl = btn.querySelector('.quality-icon');
    if (iconEl) {
      var svg;
      if (result.level === 'green') {
        svg = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7.5l3 3 5-6.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      } else if (result.level === 'orange') {
        svg = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7h8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      } else {
        svg = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 3v5M7 10.5v.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      }
      iconEl.innerHTML = svg;
    }
  }

  function initFilterPicker() {
    root.querySelectorAll('#fp-filter-picker a[data-filter]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var choice = a.getAttribute('data-filter');
        if (!(choice in MP_FILTERS)) return;
        root.querySelectorAll('#fp-filter-picker a[data-filter]').forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.filter = choice;
        render();
      });
    });
  }

  /* ===================================================================
   * Eingaben: Textfelder, Textfarbe, Scrim, Preset-Chips
   * =================================================================== */
  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null) state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }
  function initToggleRow(selector, key) {
    var btns = root.querySelectorAll(selector);
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        btns.forEach(function (x) { x.classList.remove('current'); });
        b.classList.add('current');
        state[key] = b.getAttribute('data-value');
        render();
      });
    });
    var active = root.querySelector(selector + '.current');
    if (active) state[key] = active.getAttribute('data-value');
  }
  function initPresetChips() {
    root.querySelectorAll('.fp-preset-chips [data-preset][data-target]').forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var val = c.getAttribute('data-preset') || '';
        var target = c.getAttribute('data-target');
        var input = document.getElementById(target);
        if (input) input.value = val;
        var keyMap = { 'fp-staffel': 'staffel_zeile', 'fp-cast': 'cast_zeile', 'fp-titel': 'titel' };
        var key = keyMap[target];
        if (key) state[key] = val;
        render();
      });
    });
  }
  function initUploadButton() {
    // Fotoposter-Muster: Upload-Label mit verstecktem file-input; nach Upload
    // erscheint die Change-Row (Neu zuschneiden / Anderes Foto)
    var fileInput = document.getElementById('fp-file-input');
    if (fileInput) fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (f) handleFile(f);
      fileInput.value = '';
    });
    var recrop = document.getElementById('fp-recrop-btn');
    if (recrop) recrop.addEventListener('click', function (e) { e.preventDefault(); openCropModal(); });
    var change = document.getElementById('fp-change-btn');
    if (change) change.addEventListener('click', function (e) { e.preventDefault(); if (fileInput) fileInput.click(); });
    stage.addEventListener('click', function () {
      if (isDefaultPhoto || !photoPreviewUrl) { pickPhoto(); return; }
      openCropModal();
    });
  }

  /* Info-Gluehbirne + Tabs (Standard-Muster) */
  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) close.addEventListener('click', function (e) {
        e.preventDefault();
        content.style.display = 'none';
        toggle.classList.remove('is-active');
      });
    });
  }
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['foto__wrapper', 'text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - 1:1 JG/Kalender-Schema
   * =================================================================== */
  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = parsePosterDim(state.paper_size);
    var shortE = Math.min(d.w, d.h), longE = Math.max(d.w, d.h);
    stage.style.setProperty('--collage-aspect', shortE + ' / ' + longE);
    var flat = stage.closest('.fp-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (shortE / longE) + ')';
    render();
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('fp-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
    updateQualityIndicator();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }
  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add - Kalender/JG-Muster: Sync-Render, dann /cart/add.js
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('fp-cart-btn-' + sectionId);
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    if (!state.user_image_url || isDefaultPhoto) {
      // Fotoposter-Muster (V9.96.29j): schoenes Modal statt Browser-Alert
      var noticeModal = document.getElementById('fp-cart-no-photo-modal');
      if (noticeModal) noticeModal.classList.add('visible');
      else pickPhoto();
      return;
    }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var dim = parsePosterDim(state.paper_size);
        var shortEdge = Math.min(dim.w, dim.h), longEdge = Math.max(dim.w, dim.h);

        var payload = {
          product: 'filmposter',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: shortEdge, height: longEdge, dpi: 300 },
          user_image_url: state.user_image_url,
          crop: state.crop,
          titel: state.titel,
          serie_zeile: state.serie_zeile,
          staffel_zeile: state.staffel_zeile,
          cast_zeile: state.cast_zeile,
          tagline: state.tagline,
          text_color: state.text_color,
          scrim: true,
          filter: state.filter || 'none'
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/filmposter/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/filmposter/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Fallback-URL bleibt */ }

        var props = {
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          // Cart-Vorschau (PROJ-72): persistentes Komposit vom Render-Worker
          '_preview_image_url': BACKEND_API_URL + '/media/blanket_renders/' + jobId + '_cartpreview.jpg',
          '_groesse': state.paper_size,
          '_produkt': 'filmposter',
          '_Titel': state.titel
        };
        if (state.cast_zeile && state.cast_zeile.trim()) props['_Cast'] = state.cast_zeile;
        if (state.staffel_zeile && state.staffel_zeile.trim()) props['_Staffel'] = state.staffel_zeile;
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        // Sofort-Vorschau (PROJ-72): Schnappschuss der sichtbaren Stage in
        // sessionStorage, damit der Warenkorb das Motiv SOFORT zeigt. Helper
        // ist fail-soft (2,5s-Notbremse) - blockiert den Kauf nie.
        var vorschauFertig = (window.kaSofortVorschau ? window.kaSofortVorschau(stage, jobId) : Promise.resolve());
        await vorschauFertig;

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[film-poster] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* Cart-ohne-Foto-Modal (Fotoposter-Muster): Close + Backdrop schliessen,
     CTA oeffnet den File-Picker */
  function initNoticeModal() {
    var noticeModal = document.getElementById('fp-cart-no-photo-modal');
    var noticeClose = document.getElementById('fp-cart-no-photo-close');
    var noticeCta = document.getElementById('fp-cart-no-photo-cta');
    if (!noticeModal) return;
    function close() { noticeModal.classList.remove('visible'); }
    if (noticeClose) noticeClose.addEventListener('click', close);
    noticeModal.addEventListener('click', function (e) {
      if (e.target === noticeModal) close();
    });
    if (noticeCta) noticeCta.addEventListener('click', function (e) {
      e.preventDefault();
      close();
      pickPhoto();
    });
  }

  /* ===================================================================
   * Init
   * =================================================================== */
  function init() {
    root = document.querySelector('.fp-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('fp-stage-' + sectionId);

    state.serie_zeile = root.dataset.serieZeile || '';
    state.tagline = root.dataset.tagline || '';
    if (root.dataset.defaultPhoto) {
      photoPreviewUrl = root.dataset.defaultPhoto;
      isDefaultPhoto = true;
    }
    bindField('fp-titel', 'titel');
    bindField('fp-staffel', 'staffel_zeile');
    bindField('fp-cast', 'cast_zeile');
    initToggleRow('.fp-color-btn[data-value]', 'text_color');
    initPresetChips();
    initUploadButton();
    initFilterPicker();
    initNoticeModal();
    updatePhotoUiState();
    initTabHelp();
    initTabSwitching();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('fp-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
